import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { FETCH_CONTACT_METHOD_REQUEST, UPDATE_CONTACT_METHOD_REQUEST } from "./constants";
import { Action, ContactState } from "./types";

function item(state: ContactState = {}, action: Action): ContactState {
  switch (action.type) {
    case getSuccessActionType(FETCH_CONTACT_METHOD_REQUEST):
      return action.payload;

    case getSuccessActionType(UPDATE_CONTACT_METHOD_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case UPDATE_CONTACT_METHOD_REQUEST:
    case FETCH_CONTACT_METHOD_REQUEST:
      return true;

    case getFailureActionType(UPDATE_CONTACT_METHOD_REQUEST):
    case getSuccessActionType(UPDATE_CONTACT_METHOD_REQUEST):
    case getFailureActionType(FETCH_CONTACT_METHOD_REQUEST):
    case getSuccessActionType(FETCH_CONTACT_METHOD_REQUEST):
      return false;

    default:
      return state;
  }
}

export const contact = combineReducers({ item, isFetching });
